// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Arrow_arrow__3cP2Y","reverse":"Arrow_reverse__dlpSN"};